import React from 'react';

interface IconProps extends React.SVGAttributes<SVGElement> {
  /**
   * Icon component (e.g. from react-icons). Typed loosely to bypass
   * the React 19 / react-icons return-type incompatibility.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  size?: string | number;
}

const Icon: React.FC<IconProps> = ({ icon: IconComponent, ...rest }) => {
  return React.createElement(IconComponent, rest);
};

export default Icon;
